/**
 * The ERP's definition doors (BLP/nx#3257), relative to `/v1` like every
 * `apiClient` call. One prefix, `definitions`; the backend serves nothing else
 * for forms, grids, layouts and function descriptions. Build every such URL
 * here, never by hand.
 */

const ROOT = '/definitions';

const enc = (part: string): string => encodeURIComponent(part);

/**
 * The catalog (forms, route table, menu, texts); `GET /definitions`. `lang` may
 * repeat (the texts of exactly those languages, else the negotiated one);
 * `include` adds optional members such as `layoutTemplates`.
 */
export function definitionsCatalogPath(
  query: { lang?: string[]; include?: string[] } = {}
): string {
  const params = new URLSearchParams();
  for (const lang of query.lang ?? []) params.append('lang', lang);
  for (const member of query.include ?? []) params.append('include', member);
  const qs = params.toString();
  return qs ? `${ROOT}?${qs}` : ROOT;
}

/** The grid descriptor of `key`; `GET /definitions/:key/grid`. */
export function gridDefinitionPath(key: string): string {
  return `${ROOT}/${enc(key)}/grid`;
}

/** The UI layout of `key`; `GET /definitions/:key/layout`. */
export function layoutDefinitionPath(key: string): string {
  return `${ROOT}/${enc(key)}/layout`;
}

/** One function description of `key`; `GET /definitions/:key/functions/:verb`. */
export function functionDefinitionPath(key: string, verb: string): string {
  return `${ROOT}/${enc(key)}/functions/${enc(verb)}`;
}
